// extracted by mini-css-extract-plugin
export var alertIcon = "_v8-0";